import { useState } from 'react';
import * as Dialog from '@radix-ui/react-dialog';
import { X } from 'lucide-react';

export default function ConfirmModal({
  open,
  onOpenChange,
  title,
  description,
  confirmLabel = 'Confirm',
  confirmVariant = 'danger',   // 'danger' | 'primary'
  onConfirm,
  children,                     // optional extra form fields
}) {
  const [loading, setLoading] = useState(false);

  const handleConfirm = async () => {
    setLoading(true);
    try { await onConfirm(); } finally { setLoading(false); }
  };

  const btnClass = confirmVariant === 'danger'
    ? 'bg-[#E57373] hover:bg-[#EF5350] text-white'
    : 'bg-[#6C63FF] hover:bg-[#5B52CC] text-white';

  return (
    <Dialog.Root open={open} onOpenChange={onOpenChange}>
      <Dialog.Portal>
        <Dialog.Overlay className="fixed inset-0 bg-black/40 z-50 animate-in fade-in" />
        <Dialog.Content className="fixed z-50 left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2 w-full max-w-md bg-white rounded-2xl shadow-xl p-6 border border-[#E8E6F8]">
          <div className="flex items-start justify-between mb-4">
            <Dialog.Title className="text-base font-heading font-bold text-[#1A1A2E]">
              {title}
            </Dialog.Title>
            <Dialog.Close className="text-[#9CA3AF] hover:text-[#6B7280]">
              <X className="h-4 w-4" />
            </Dialog.Close>
          </div>

          {description && (
            <p className="text-sm text-[#6B7280] font-body mb-4">{description}</p>
          )}

          {children}

          <div className="flex gap-3 justify-end mt-6">
            <Dialog.Close className="px-4 py-2 text-sm font-body text-[#6B7280] border border-[#E8E6F8] rounded-lg hover:bg-[#F5F4FB]">
              Cancel
            </Dialog.Close>
            <button
              onClick={handleConfirm}
              disabled={loading}
              className={`px-4 py-2 text-sm font-body rounded-lg transition-colors disabled:opacity-60 ${btnClass}`}
            >
              {loading ? 'Processing…' : confirmLabel}
            </button>
          </div>
        </Dialog.Content>
      </Dialog.Portal>
    </Dialog.Root>
  );
}
